export default __webpack_public_path__ + "d6dedaaa48b30b1dfeceac988e9ede69.png";